import { useNavigate, Link } from 'react-router-dom';
import EnergyYearComparison from '../components/EnergyYearComparison';
import '../css/Home.css';
import '../css/Energie.css';
import CustomModal from '../components/CustomModal';
import React, { useState, useMemo, useEffect } from 'react';
import axios from 'axios';
import Masonry from 'react-masonry-css';
import DegreeDaysUsageWidget from '../components/DegreeDaysUsageWidget'; 
import api from '../components/api';
import WidgetEnergyCompare from '../components/WidgetEnergyCompare';
import EnergyComparisonWidget2 from '../components/EnergyComparisonWidget2'; // New widget
import BeheerdersportaalSidebar from '../components/BeheerdersportaalSidebar';
import VoorschotBeheer from './VoorschotBeheer';
import GasComparisonWidget from '../components/GasComparisonWidget';

const Energie = () => {
  const navigate = useNavigate();

  const [showPredictionModal, setShowPredictionModal] = useState(false);
  const [predictionComparison, setPredictionComparison] = useState([]);
  const [lastMongoDate, setLastMongoDate] = useState(null);
  const baseURL = process.env.REACT_APP_API_URL || 'http://localhost:5001'; // fallback in dev
  const [sidebarOpen, setSidebarOpen] = useState(window.innerWidth > 768);

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('loginTimestamp');
    // Redirect to home page, not login
    navigate('/home');
  };

  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'ascending' });

  const sortedPrediction = useMemo(() => {
    const sorted = [...predictionComparison];
    if (sortConfig.key) {
      sorted.sort((a, b) => {
        let aVal = a[sortConfig.key];
        let bVal = b[sortConfig.key];
  
        // Special handling for % Change (handle N/A and convert to number)
        if (sortConfig.key === 'percent') {
          const aIsNa = aVal === 'N/A' || aVal === null || aVal === undefined;
          const bIsNa = bVal === 'N/A' || bVal === null || bVal === undefined;
  
          if (aIsNa && bIsNa) return 0;
          if (aIsNa) return 1;
          if (bIsNa) return -1;
  
          aVal = parseFloat(aVal);
          bVal = parseFloat(bVal);
        }
  
        if (aVal === null || aVal === undefined) return 1;
        if (bVal === null || bVal === undefined) return -1;
  
        if (typeof aVal === 'string') {
          return sortConfig.direction === 'ascending'
            ? aVal.localeCompare(bVal)
            : bVal.localeCompare(aVal);
        }
  
        return sortConfig.direction === 'ascending' ? aVal - bVal : bVal - aVal;
      });
    }
    return sorted;
  }, [predictionComparison, sortConfig]);
  
  const handleSort = (key) => {
    setSortConfig((prev) => {
      const direction =
        prev.key === key && prev.direction === 'ascending' ? 'descending' : 'ascending';
      return { key, direction };
    });
  };

  useEffect(() => {
    api.get(`${baseURL}/api/ista/last-date`)
      .then(res => {
        console.log('✅ Last date from MongoDB:', res.data.lastDate);
        setLastMongoDate(res.data.lastDate); // Save to state
      })
      .catch(err => {
        console.error('❌ Could not fetch last date:', err);
        setLastMongoDate('N/A'); // fallback
      });
  }, [baseURL]);
  
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 768) {
        setSidebarOpen(false);
      } else {
        setSidebarOpen(true);
      }
    };
    
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const toggleSidebar = () => {
    setSidebarOpen(prev => !prev);
  };

  const openExternalLink = (url) => {
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  return (
    <div className="beheer-wrapper">
      <BeheerdersportaalSidebar>
        {/* Main content */}
        <main className="dashboard energie-page">
          <div className="home-container">
            <div className="home-overlay">
              <div className="mb-4 w-full text-left">
                {lastMongoDate && lastMongoDate !== 'N/A' ? (
                  <p className="text-sm text-gray-700">
                    📅 Last update: <strong>
                      {new Date(lastMongoDate).toLocaleDateString('nl-NL', {
                        year: 'numeric',
                        month: 'long',
                        day: 'numeric'
                      })}
                    </strong>
                  </p>
                ) : (
                  <p className="text-sm text-gray-500">📅 Loading last update...</p>
                )}
              </div>

              <div className="spacer" style={{ marginTop: "40px" }}></div>

              {/* Masonry layout for widgets */}
              <Masonry
                breakpointCols={{
                  default: 3,  // 3 columns on desktop
                  1200: 2,     // 2 columns on smaller desktop/tablets
                  768: 1       // 1 column on mobile
                }}
                className="my-masonry-grid"
                columnClassName="my-masonry-grid_column"
              >

<div className="card">
                {/* New Attractive Energy Comparison Widget */}
                <EnergyComparisonWidget2 onNavigate={navigate} />
                </div>

                    {/* Widget: Voorschotten Beheer */}
                    <div className="card">
                  <h3>💶 Voorschotten Beheer</h3>
                  <p>Beheer de maandelijkse voorschotten voor gas van alle bewoners.</p>
                  <button className="button" onClick={() => navigate('/voorschotbeheer')}>
                    Ga naar Voorschotten Beheer
                  </button>
                </div>

                {/* Widget: ISTA Admin Panel Button */}
     <div className="card">
                  <h3>📊 Kenter Admin Panel</h3>
                  <p>Access advanced energy usage management tools and detailed reports.</p>
                  <button className="button" onClick={() => navigate('/kenter-admin')}>
                    🔧 Go to Kenter Admin Panel
                  </button>
                </div>

                  

                    {/* Widget: ISTA Admin Panel Button */}
                    <div className="card">
                  <h3>📊 ISTA Admin Panel</h3>
                  <p>Access advanced energy usage management tools and detailed reports.</p>
                  <button className="button" onClick={() => navigate('/ista-admin')}>
                    🔧 Go to ISTA Admin Panel
                  </button>
                </div>

  {/* Monthly Energy Usage Widget */}
  <div className="card">
                  <WidgetEnergyCompare />
                </div>

  {/* Monthly Energy Usage Widget */}
  <div className="card">
                 <GasComparisonWidget />
                 </div>

                   {/* Widget: Degree Days vs. Energy Usage */}
     <DegreeDaysUsageWidget />

                {/* Widget: Temperature Trends */}
                <div className="card">
                  <h3>🌡️ Temperature Trends</h3>
                  <p>View how temperature affects energy usage patterns in your building.</p>
                  <button className="button" onClick={() => navigate('/degree-days')}>
                    View Temperature Analysis
                  </button>
                </div>

  
            

       
              </Masonry>

              {/* Modal for prediction comparison */}
              <CustomModal isOpen={showPredictionModal} onClose={() => setShowPredictionModal(false)}>
                <div className="prediction-modal">
                  <div className="modal-title">📊 Prediction vs Previous Year Comparison</div>
                  <div className="sticky-table-container">
                    {/* Fixed header table */}
                    <table className="sticky-header-table">
                      <thead>
                        <tr>
                          <th onClick={() => handleSort('homeNumber')} className="cursor-pointer">🏠 Apartment</th>
                          <th onClick={() => handleSort('predicted')} className="cursor-pointer">Predicted</th>
                          <th onClick={() => handleSort('previous')} className="cursor-pointer">Previous Year</th>
                          <th onClick={() => handleSort('diff')} className="cursor-pointer">Difference</th>
                          <th onClick={() => handleSort('percent')} className="cursor-pointer">% Change</th>
                        </tr>
                      </thead>
                    </table>
                    
                    {/* Scrollable content */}
                    <div className="table-scroll-container">
                      <table className="content-table">
                        <tbody>
                          {sortedPrediction.map((row, i) => {
                            const percent = row.percent === 'N/A' ? null : parseFloat(row.percent);
                            const highlight = percent !== null && Math.abs(percent) > 15;
                            return (
                              <tr
                                key={i}
                                style={{
                                  backgroundColor:
                                    highlight
                                      ? percent > 0
                                        ? '#ffe5e5'
                                        : '#e5ffe5'
                                      : 'transparent',
                                }}
                              >
                                <td>{row.homeNumber}</td>
                                <td>{row.predicted}</td>
                                <td>{row.previous}</td>
                                <td className={row.diff > 0 ? 'text-red-600' : 'text-green-600'}>
                                  {row.diff}
                                </td>
                                <td>{row.percent}%</td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </CustomModal>
            </div>
          </div>
        </main>
      </BeheerdersportaalSidebar>
    </div>
  );
};

export default Energie;